import PaymentStatusesMap from '@/structures/paymentStatuses.js';

export default {
  // Initialize data, amount, currency, and everything else
  invoiceInitialData: {},
  commerceAccountData: null,

  publicKey: null,
  currency: null,
  amount: null,

  paymentMethods: null,
  stateLoading: false,

  methods: null,
  disabled_methods: [],

  services: null,
  disabled_services: [],

  // Just array with categories name ['all', 'alternative']
  categories: null,
  // Object with categories name as key fex: { alternative : {name: "alternative", code:"alt", logo:"..."} etc.}
  groupedCategories: null,
  // Current category info, selected from navbar.
  selectedCategory: 'all',

  // API initializ
  public_key: null,
  description: null,

  // UI theme to use
  currentTheme: 'basic',

  step: 1,

  // Setted on list page @/pages/PaymentMethodItemsList on method click
  selectedMethod: null,

  // Setted on payment method page
  selectedService: null,

  // Got this from API response on payment invoice creation
  flowData: {},

  // Just simple flag to indicate that start page ready, MVP
  showGlobalLoader: false,

  // Indicator that shows payment preRequest / state building process
  isApplicationReady: false,

  // Will be added query of requests.
  asyncRequests: [],

  // Payment invoice data for checking the PI status, and ID
  paymentInvoiceData: {},

  // Auto process Data, if query has service and service_fields params
  autoProcessData: null,

  paymentInvoiceStatuses: PaymentStatusesMap,

  currentStep: 1,

  searchData: '',
  navigationData: [],

  globalError: null,

  statusBar: {
    step: 1,
    label: 'step__service_select',
  },

  // controls the view of flow_data when flow is "invoice"
  isInvoiceFlowDataShown: false,
};
